import styled from '@emotion/styled';
import { GUTTER_WIDTH } from './config';

interface RowProps {
  align?: 'normal' | 'flex-start' | 'center' | 'flex-end' | 'stretch';
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'initial' | 'inherit';
  nogutter?: boolean;
  nowrap?: boolean;
}

export const Row = styled.div<RowProps>`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: ${({ align = 'normal' }) => align };
  justify-content: ${({ justify = 'flex-start' }) => justify };
  flex-wrap: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'};
  margin-left: ${({ nogutter }) => nogutter ? 0 : `-${GUTTER_WIDTH / 2}px`};
  margin-right: ${({ nogutter }) => nogutter ? 0 : `-${GUTTER_WIDTH / 2}px`};
`;
